import { createActionGroup, emptyProps } from '@ngrx/store';

export const BadgeActions = createActionGroup({
  source: 'Badge',
  events: {
    recalculate: emptyProps()
  }
});
